import React from 'react'
import '../styles/_risks.scss';
import { useTranslation } from 'react-i18next';
import { HeaderPmr } from '../../components/HeaderPmr/HeaderPmr';
import { mapGeneralInfoInDataSource } from '../../utils/Helpers/MapperHelper';
import { RisksDescription } from '../../components/RisksDescription/RisksDescription';

export const RisksSection = ({ data }) => {
    const { t } = useTranslation();
    const dataSource = data.sectionFourRiskOrProduct?.risk;

    const {
        riskCountSeverity
    } = dataSource;

    return (
        <section className='risks-report'>
            <HeaderPmr data={mapGeneralInfoInDataSource(data)} />
            <article className="risks-info-report">
                <h3 className='content-layout-title'>{t('extended_report.risks')}</h3>
                <section className='risks-info-layout'>
                    <div className='general-stats'>
                        {
                            riskCountSeverity.map((risk, index) => {
                                return (
                                    <div key={index} className='stats-item'>
                                        <h1>{risk.countSeverity}</h1>
                                        <span>{t('severity')}</span>
                                        <div className='risks-status-item'>
                                            <span
                                                data-testid="bullet"
                                                className="bullet"
                                                style={{ backgroundColor: risk.colorSeverity }}
                                            ></span>
                                            <span>{t(risk.nameSeverity).toUpperCase()}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={'risk-description' + (!data.risksDescriptions?.length ? ' empty' : '')}>
                        <RisksDescription risks={data.risksDescriptions || []} />
                    </div>
                </section>
            </article>
        </section>
    );
};
